import Login from "@/pages/login";
import AdminDashboard from "@/pages/admin-dashboard";
import { HelmetProvider } from 'react-helmet-async';
import { NotificationProvider } from "@/contexts/NotificationContext";
import SEO from '@/components/seo';
import { useAuthContext } from '@/contexts/AuthContext';
import { useEffect } from "react";

const AppContent = () => {
  const { authenticated, updateAuthentication } = useAuthContext();

  useEffect(() => {
    updateAuthentication();
  }, []);

  return (
    <NotificationProvider>
      <HelmetProvider>
        <SEO />
        <main className="flex h-screen flex-col">
          {!authenticated ? (
            <Login />
          ) : (
            <AdminDashboard />
          )}
        </main>
      </HelmetProvider>
    </NotificationProvider>
  );
};

export default AppContent;
